import type { PddAfterSalesMetrics } from '../pinduoduoAfterSales'
import type { PinduoduoAllocatedSecondReturnLossEstimate } from '../pinduoduoSecondReturnLoss'
import { integer, money, percent } from '../utils'
import { MetricStrip } from './MetricStrip'

export function PinduoduoAfterSalesCostSection({
  metrics,
  loss,
  profitAfterSecondReturnLoss,
  profitComplete,
  loading,
  scopeLabel,
}: {
  metrics: PddAfterSalesMetrics
  loss: PinduoduoAllocatedSecondReturnLossEstimate
  profitAfterSecondReturnLoss: number | null
  profitComplete: boolean
  loading: boolean
  scopeLabel: 'SPU' | 'SKU'
}) {
  return <section className="overview-section">
    <div className="section-heading-row"><div><h2>售后与二退成本</h2><p>退回默认可再入库；二退只计往返履约与部分折损，履约成本按件数比例分摊避免跨{scopeLabel}重复计算</p></div><span>{integer(loss.secondReturnItemCount)} 件二退</span></div>
    <MetricStrip items={[
      { label: '售后申请', value: loading ? '加载中' : integer(metrics.applicationCount), context: '申请日期口径' },
      { label: '一退', value: loading ? '加载中' : integer(metrics.unshippedCount), context: '申请时未发货' },
      { label: '二退', value: loading ? '加载中' : integer(metrics.shippedCount), context: '申请时已发货' },
      { label: '成功退款', value: loading ? '加载中' : integer(metrics.successfulRefundCount), context: money(metrics.successfulRefundAmount) },
      { label: loss.complete ? '二退成本' : '已覆盖二退成本', value: loading ? '加载中' : money(loss.totalLoss), context: `货损覆盖 ${integer(loss.coveredDamageItemCount)} / ${integer(loss.secondReturnItemCount)} 件` },
      { label: profitComplete && loss.complete ? '二退后利润参考' : '已覆盖二退后利润参考', value: loading || profitAfterSecondReturnLoss === null ? '—' : money(profitAfterSecondReturnLoss), context: '含返点利润－二退成本；未分摊广告费' },
    ]} />
    <div className="table-responsive"><table className="pdd-table"><thead><tr><th>二退成本项目</th><th>计算规则</th><th>金额</th></tr></thead><tbody>
      <tr><td><strong>往返运费分摊</strong></td><td>全店往返运费 × 本{scopeLabel}二退件数占比 {percent(loss.fulfillmentAllocationRate * 100)}</td><td>{money(loss.allocatedRoundTripFreightCost)}</td></tr>
      <tr><td><strong>包装损耗分摊</strong></td><td>全店包装损耗 × 本{scopeLabel}二退件数占比</td><td>{money(loss.allocatedPackagingLoss)}</td></tr>
      <tr><td><strong>预计产品货损</strong></td><td>可再售前提下，本{scopeLabel}产品成本 × 5% 折损；不扣整件成本</td><td>{money(loss.expectedDamageCost)}</td></tr>
      <tr className="calc-major"><td><strong>＝ {loss.complete ? '二退成本' : '已覆盖二退成本'}</strong></td><td>分摊往返运费＋分摊包装损耗＋预计产品货损</td><td><strong>{money(loss.totalLoss)}</strong></td></tr>
    </tbody></table></div>
  </section>
}
